import React from "react";

const InfoIcon = (props: any) => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.99984 12.8337C8.61065 12.8337 10.069 12.1807 11.1246 11.1251C12.1802 10.0695 12.8332 8.61114 12.8332 7.00033C12.8332 5.38951 12.1802 3.93118 11.1246 2.87553C10.069 1.81991 8.61065 1.16699 6.99984 1.16699C5.38902 1.16699 3.93069 1.81991 2.87505 2.87553C1.81942 3.93118 1.1665 5.38951 1.1665 7.00033C1.1665 8.61114 1.81942 10.0695 2.87505 11.1251C3.93069 12.1807 5.38902 12.8337 6.99984 12.8337Z"
        stroke="var(--color-stroke-active)"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00016 4.72591C7.40287 4.72591 7.72933 4.39945 7.72933 3.99674C7.72933 3.59404 7.40287 3.26758 7.00016 3.26758C6.59746 3.26758 6.271 3.59404 6.271 3.99674C6.271 4.39945 6.59746 4.72591 7.00016 4.72591Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M7 5.83301V10.4997"
        stroke="var(--color-stroke-active)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
